import { useState } from "react";
import { useLocation } from "react-router-dom";
import { initialNavbarSections } from "../../utils/SupplierContainer/navConfig";
import { RouteNames } from "layout/utils/SupplierContainer/routes";

export interface IMenuItem {
    label: string;
    path?: string;
    disabled?: boolean;
  }
  
  export interface IManagementNavbarProps {
    label: string;
    menuItems: IMenuItem[];
    path: string;
  }
  

export const useNavbarManagement = () => {
    const location = useLocation();
    const [currentNavbarSections, setNavbarSections] = useState(
        initialNavbarSections
    );

    const adjustNavbarListLeadDetails = (
        supplierId: string,
        isAuthenticated: boolean,
        isVpParther: boolean | undefined
    ) => {
        const currentRoute = location.pathname;
        var basePath = "";

        // If user is using details route
        const capacityOrWaitingListRoute =
            currentRoute.match(RouteNames.CAPACITY_LEAD_DETAILS) ||
            currentRoute.match(RouteNames.WAITING_LIST_DETAILS);

        if (capacityOrWaitingListRoute != null) {
            basePath =
                currentRoute.match(
                    new RegExp(
                        `(.*\\/${capacityOrWaitingListRoute?.[0]}\\/[^/]+)`
                    )
                )?.[1] || "";
        }

        // If user is using booking route
        else if (
            isAuthenticated == false &&
            currentRoute.match(
                new RegExp(new RegExp(`^\\/${supplierId}\\/(.*)`))
            )
        ) {
            basePath = "/" + supplierId;
        }

        var updatedSections = currentNavbarSections.map((section) => {
            let path = section.path;

            if (section.label === "Kontaktdaten") {
                path = `${basePath}/contact`;
            } else if (section.label === "Zielgebiet") {
                path = `${basePath}/zip-code`;
            }

            return {
                ...section,
                path,
                menuItems: section.menuItems.map((item: IMenuItem) => {
                    if (item.label === "Klientenübersicht" && item.path) {
                        return {
                            ...item,
                            path:
                                capacityOrWaitingListRoute != null &&
                                !isAuthenticated &&
                                supplierId != ""
                                    ? currentRoute.replace(
                                          new RegExp(
                                              `(\\/${capacityOrWaitingListRoute?.[0]}\\/[^/]+).*`
                                          ),
                                          "$1"
                                      )
                                    : item.path,
                            disabled:
                                !isAuthenticated &&
                                capacityOrWaitingListRoute == null
                        };
                    }

                    if (item.label === "Buchungen") {
                        //If menu has already /:supplierId is Buchungen route then do not take it
                        //Make it emepty

                        //If BasePath comming from /waitingList/:secureId Or /capactiyLead/:secureId then take it
                        var bookingBasePath = basePath;
                        if (basePath == "/" + supplierId) bookingBasePath = "";
                        return {
                            ...item,
                            path: `${bookingBasePath}/${supplierId}/booking`
                        };
                    }

                    if (item.label === "Klient erstellen") {
                        return {
                            ...item,
                            disabled: !isAuthenticated
                        };
                    }

                    return item;
                })
            };
        });

        if (isVpParther == false && isVpParther != undefined) {
            if (!updatedSections.some((x) => x.label === "Zielgebiet")) {
                updatedSections.push({
                    label: "Zielgebiet",
                    menuItems: [],
                    path: `${basePath}/zip-code`
                });
            }
            if (!updatedSections.some((x) => x.label === "Kontaktdaten")) {
                updatedSections.push({
                    label: "Kontaktdaten",
                    menuItems: [],
                    path: `${basePath}/contact`
                });
            }
        }
        setNavbarSections((prev) =>
            JSON.stringify(prev) === JSON.stringify(updatedSections)
                ? prev
                : updatedSections
        );
    };

    return {
        currentNavbarSections,
        adjustNavbarListLeadDetails
    };
};
